import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from "prop-types";
import React, { Component } from "react";
import debounce from "lodash/debounce";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import Alert from "../../elements/Alert";
import Button from "../../elements/Button";
import Group from "../../elements/Group";
import VerticalSpacing from "../../elements/VerticalSpacing";
import { API_ENDPOINTS } from "../../utilities/configuration/endpoints";
import CampaignControl from "./components/CampaignControl";
import CheckboxControl from "./components/CheckboxControl";
import Fieldset from "./components/Fieldset";
import PrivacyControl from "./components/PrivacyControl";
import RadioControl from "./components/RadioControl";
import { RadioInput } from "./components/RadioControl/RadioInput";
import SelectControl from "./components/SelectControl";
import TextareaControl from "./components/TextareaControl";
import TextControl from "./components/TextControl";
import { Consumer as FormOnSubmitSuccessContextConsumer } from "./formOnSubmitSuccessContext";
import { fireFormStart, fireFormSubmitSuccess, fireFormSubmitFailure, sendFormDataToChiliPiper, submit, validateEmail, validateTel, validateFormData } from "./utilities";
var INVALID_DEBOUNCE_TIME = 1000;
var fireFormSubmitFailureThrottled = debounce(fireFormSubmitFailure, INVALID_DEBOUNCE_TIME);

var Form = /*#__PURE__*/function (_Component) {
  _inherits(Form, _Component);

  var _super = _createSuper(Form);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "submitApigeeForm", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(formData) {
        var formProps, errors;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formProps = {
                  recaptchaApiKey: _this.props.recaptchaApiKey,
                  recaptchaSiteKey: _this.props.recaptchaSiteKey,
                  eloquaFormName: _this.props.formName,
                  eloquaSiteId: _this.props.elqId,
                  messageType: _this.props.messageType,
                  redirectPage: _this.props.redirectPage,
                  inlineMessage: _this.props.inlineMessage,
                  formAction: _this.props.action,
                  formData: formData
                };
                errors = validateFormData(_this.formEl);

                if (!errors.length) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", {
                  data: {
                    failType: "message",
                    failMessage: errors.join(" ")
                  }
                });

              case 4:
                _context.next = 6;
                return window.UeFalcon.sendFormDataToApigee(formProps);

              case 6:
                return _context.abrupt("return", _context.sent);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleChiliPiperIntegration", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response, formData) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this.props.isChiliPiperEnabled && _this.props.chiliPiperRouterId)) {
                  _context2.next = 9;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return sendFormDataToChiliPiper(response, formData, _this.props.chiliPiperRouterId);

              case 4:
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](1);
                // eslint-disable-next-line no-console
                console.error("Error calling Chili Piper:", _context2.t0);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 6]]);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "submitHandler", function (event, onSubmitSuccess) {
      if (_this.props.onSubmit) {
        _this.props.onSubmit(event);
      } else {
        _this.handleSubmit(event, onSubmitSuccess);
      }
    });

    _this.state = {
      hasStarted: false,
      responseMessage: "",
      responseState: Form.responseStates.NONE
    };
    _this.getClassName = getClassNameFactory(Form.displayName);
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleInvalid = _this.handleInvalid.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.getHashableIdentifier = _this.getHashableIdentifier.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Form, [{
    key: "handleInvalid",
    value: function handleInvalid(event, showHideInvalidMessage) {
      event.preventDefault();
      showHideInvalidMessage(event, true);
      var firstInvalidElement = this.formEl.querySelector(".is-invalid");

      if (firstInvalidElement) {
        firstInvalidElement.focus();
      }

      var invalidFieldNames = [];
      var invalidFields = this.formEl.querySelectorAll(":invalid");

      var _iterator = _createForOfIteratorHelper(invalidFields),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;
          invalidFieldNames.push(field.name);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      fireFormSubmitFailureThrottled({
        invalidFieldNames: invalidFieldNames,
        name: this.props.analyticsName,
        type: this.props.analyticsType
      });
    }
  }, {
    key: "showHideInvalidMessage",
    value: function showHideInvalidMessage(event, showMessage) {
      var _eventTarget$closest;

      var eventTarget = event.target;
      var message = (_eventTarget$closest = eventTarget.closest("label")) === null || _eventTarget$closest === void 0 ? void 0 : _eventTarget$closest.querySelector(".tr-Form-errorMessage");

      if (!message) {
        return;
      }

      if (showMessage) {
        message.classList.remove("is-hidden");
        eventTarget.classList.add("is-invalid");
        eventTarget.setAttribute("aria-invalid", "true");
      } else {
        message.classList.add("is-hidden");
        eventTarget.classList.remove("is-invalid");
        eventTarget.setAttribute("aria-invalid", "false");
      }

      message.ariaHidden = "".concat(!showMessage);
    }
  }, {
    key: "validateField",
    value: function validateField(event, showHideInvalidMessage) {
      var field = event.target;
      var isNotValid = false;
      var isRequiredAndEmpty = field.required && !field.value;

      if (field.type === "tel") {
        // Check both format (if has value) and required status
        var hasValueAndInvalid = field.value ? validateTel(field.value) : false;
        isNotValid = isRequiredAndEmpty ? true : hasValueAndInvalid;
      } // Handle email validation - both optional and required
      else if (field.type === "email") {
          var _hasValueAndInvalid = field.value ? validateEmail(field.value) : false;

          isNotValid = isRequiredAndEmpty ? true : _hasValueAndInvalid;
        } // eslint-disable-next-line no-negated-condition
        else if (!field.required) {
            return;
          } else {
            isNotValid = !field.value;
          }

      showHideInvalidMessage(event, isNotValid);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      if (this.state.hasStarted === true) {
        return;
      }

      if (this.props.onFocusAnalytics) {
        this.props.onFocusAnalytics(event);
      } else {
        fireFormStart({
          name: this.props.analyticsName,
          type: this.props.analyticsType
        });
      }

      this.setState({
        hasStarted: true
      });
    }
  }, {
    key: "getHashableIdentifier",
    value: function getHashableIdentifier() {
      var hashableIdentifierEl = this.formEl.querySelector("[data-hashable-identifier=true]");
      return hashableIdentifierEl && hashableIdentifierEl.value || false;
    }
    /* eslint-disable complexity */

  }, {
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(event) {
        var onSubmitSuccess,
            submitAction,
            formData,
            response,
            _this$formEl$querySel,
            _this$formEl$querySel2,
            errorMessage,
            responseMessage,
            _this$formEl$querySel3,
            _this$formEl$querySel4,
            _errorMessage,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                onSubmitSuccess = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : function () {};

                if (!(this.props.ajax && this.state.responseState !== Form.responseStates.LOADING)) {
                  _context3.next = 46;
                  break;
                }

                event.preventDefault();
                this.setState({
                  responseMessage: "",
                  responseState: Form.responseStates.LOADING
                });
                submitAction = this.createPostUrl(this.props.action);
                formData = new FormData(this.formEl);

                if (!(this.props.endpoint === API_ENDPOINTS.APIGEE)) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 9;
                return this.submitApigeeForm(formData);

              case 9:
                _context3.t0 = _context3.sent.data;
                _context3.next = 15;
                break;

              case 12:
                _context3.next = 14;
                return submit(submitAction, formData);

              case 14:
                _context3.t0 = _context3.sent;

              case 15:
                response = _context3.t0;

                if (!(response.action === "redirect")) {
                  _context3.next = 27;
                  break;
                }

                if (!(response.state === "success")) {
                  _context3.next = 24;
                  break;
                }

                fireFormSubmitSuccess({
                  hashableIdentifier: this.getHashableIdentifier(),
                  name: this.props.analyticsName,
                  type: this.props.analyticsType,
                  email: (_this$formEl$querySel = this.formEl.querySelector("input[type=email]")) === null || _this$formEl$querySel === void 0 ? void 0 : _this$formEl$querySel.value,
                  tel: (_this$formEl$querySel2 = this.formEl.querySelector("input[type=tel]")) === null || _this$formEl$querySel2 === void 0 ? void 0 : _this$formEl$querySel2.value
                });
                _context3.next = 21;
                return this.handleChiliPiperIntegration(response, formData);

              case 21:
                if (!this.props.isChiliPiperEnabled) {
                  /* Wait until the call stack has cleared before completing the redirect.
                     This should give the browser time to commit any cookies set by the
                     network response.*/
                  setTimeout(function () {
                    return window.location.assign(response.location);
                  }, 0);
                }

                _context3.next = 26;
                break;

              case 24:
                errorMessage = response.statusCode ? ["".concat(response.statusCode, ":").concat(response.errorMessage || response.message)] : [];
                fireFormSubmitFailure({
                  invalidFieldNames: errorMessage,
                  name: this.props.analyticsName,
                  type: this.props.analyticsType
                });

              case 26:
                return _context3.abrupt("return");

              case 27:
                if (!(response.state === "success")) {
                  _context3.next = 38;
                  break;
                }

                if (!(response.action === "inlineMessage")) {
                  _context3.next = 34;
                  break;
                }

                _context3.next = 31;
                return this.handleChiliPiperIntegration(response, formData);

              case 31:
                responseMessage = response.message;
                _context3.next = 35;
                break;

              case 34:
                if (response.action === "unknown") {
                  responseMessage = this.props.defaultSuccessMessage;
                }

              case 35:
                fireFormSubmitSuccess({
                  hashableIdentifier: this.getHashableIdentifier(),
                  name: this.props.analyticsName,
                  type: this.props.analyticsType,
                  email: (_this$formEl$querySel3 = this.formEl.querySelector("input[type=email]")) === null || _this$formEl$querySel3 === void 0 ? void 0 : _this$formEl$querySel3.value,
                  tel: (_this$formEl$querySel4 = this.formEl.querySelector("input[type=tel]")) === null || _this$formEl$querySel4 === void 0 ? void 0 : _this$formEl$querySel4.value
                });
                _context3.next = 41;
                break;

              case 38:
                if (response.failType === "message") {
                  responseMessage = response.failMessage;
                } else if ( // handle error arising from Recaptcha
                response.contactLink && response.contactLinkText && response.message) {
                  responseMessage = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, response.message), /*#__PURE__*/React.createElement("a", {
                    href: response.contactLink,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, response.contactLinkText));
                } else {
                  responseMessage = this.props.defaultFailMessage;
                }

                _errorMessage = response.statusCode ? ["".concat(response.statusCode, ":").concat(response.errorMessage || response.message)] : [];
                fireFormSubmitFailure({
                  invalidFieldNames: _errorMessage,
                  name: this.props.analyticsName,
                  type: this.props.analyticsType
                });

              case 41:
                this.setState({
                  responseMessage: responseMessage,
                  responseState: response.state === "success" ? Form.responseStates.SUCCESS : Form.responseStates.FAILURE
                });

                if (responseMessage) {
                  this.responseEl.scrollIntoView(false);
                }

                if (!response.exception) {
                  _context3.next = 45;
                  break;
                }

                throw response.exception;

              case 45:
                if (response.state === "success") {
                  onSubmitSuccess();
                }

              case 46:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleSubmit(_x4) {
        return _handleSubmit.apply(this, arguments);
      }

      return handleSubmit;
    }()
    /* eslint-enable complexity */

  }, {
    key: "isTestSubmission",
    get: function get() {
      return new URL(window.location).searchParams.get("test-submission") === "true";
    }
  }, {
    key: "createPostUrl",
    value: function createPostUrl(url) {
      if (this.isTestSubmission) {
        return "".concat(url, "?test-submission=true");
      }

      return url;
    }
  }, {
    key: "addGatedParamToPageUrl",
    value: function addGatedParamToPageUrl(action) {
      var urlParams = new URLSearchParams(window.location.search);
      var paramName = "gatedContent";

      if (!urlParams.get(paramName)) {
        var url = new URL(action.replace(".ewp.json", ".gated.json"), window.location.origin);
        var statusCode = 200;
        fetch(url).then(function (res) {
          if (res.status === statusCode) {
            res.json().then(function (data) {
              if (data.action && data.action === paramName) {
                urlParams.set(paramName, data.location);
                window.location.search = urlParams;
              }
            });
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          responseMessage = _this$state.responseMessage,
          responseState = _this$state.responseState;
      var _this$props = this.props,
          action = _this$props.action,
          ajax = _this$props.ajax,
          formName = _this$props.formName,
          analyticsName = _this$props.analyticsName,
          analyticsType = _this$props.analyticsType,
          children = _this$props.children,
          footer = _this$props.footer,
          header = _this$props.header,
          id = _this$props.id,
          method = _this$props.method,
          submitButtonText = _this$props.submitButtonText,
          submitButtonTextLoading = _this$props.submitButtonTextLoading,
          submitButtonTextSuccess = _this$props.submitButtonTextSuccess,
          target = _this$props.target,
          noValidate = _this$props.noValidate,
          hasRedirect = _this$props.hasRedirect,
          formResource = _this$props.formResource;

      if (hasRedirect && formResource) {
        this.addGatedParamToPageUrl(formResource);
      }

      var postUrl = this.createPostUrl(action);
      var buttonText;
      var isDisabled = false;
      var isLoading = false;

      switch (responseState) {
        case Form.responseStates.SUCCESS:
          buttonText = submitButtonTextSuccess;
          isDisabled = true; // Disable submission; it's already been submitted

          break;

        case Form.responseStates.FAILURE:
          buttonText = submitButtonText; // Allow for resubmission

          break;

        case Form.responseStates.LOADING:
          buttonText = submitButtonTextLoading;
          isLoading = true;
          break;

        default:
          buttonText = submitButtonText;
          break;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName(),
        "data-action": postUrl,
        "data-ajax": ajax,
        "data-form-name": formName,
        "data-has-redirect": hasRedirect,
        "data-analytics-name": analyticsName,
        "data-analytics-type": analyticsType,
        "data-id": id,
        "data-rehydratable": getRehydratableName(Form.displayName),
        "data-submit-button-text": submitButtonText,
        "data-recaptcha-site-key": this.props.recaptchaSiteKey,
        "data-recaptcha-api-key": this.props.recaptchaApiKey,
        "data-redirect-page": this.props.redirectPage,
        "data-form-resource": formResource,
        "data-message-type": this.props.messageType,
        "data-inline-message": this.props.inlineMessage,
        "data-endpoint": this.props.endpoint,
        "data-elq-id": this.props.elqId,
        "data-is-chili-piper-enabled": this.props.isChiliPiperEnabled,
        "data-chili-piper-router-id": this.props.chiliPiperRouterId
      }, /*#__PURE__*/React.createElement(FormOnSubmitSuccessContextConsumer, null, function (onSubmitSuccess) {
        return /*#__PURE__*/React.createElement("form", {
          action: postUrl,
          id: id,
          method: method,
          onFocus: _this2.handleFocus,
          onInvalid: function onInvalid(event) {
            return _this2.handleInvalid(event, _this2.showHideInvalidMessage);
          },
          onInput: function onInput(event) {
            return _this2.validateField(event, _this2.showHideInvalidMessage);
          },
          onBlur: function onBlur(event) {
            return _this2.validateField(event, _this2.showHideInvalidMessage);
          },
          onSubmit: function onSubmit(event) {
            return _this2.submitHandler(event, onSubmitSuccess);
          },
          ref: function ref(_ref4) {
            _this2.formEl = _ref4;
          },
          target: target,
          noValidate: noValidate
        }, header && /*#__PURE__*/React.createElement(VerticalSpacing, {
          size: "s"
        }, /*#__PURE__*/React.createElement("div", {
          className: _this2.getClassName({
            descendantName: "header"
          })
        }, header)), /*#__PURE__*/React.createElement(VerticalSpacing, null, /*#__PURE__*/React.createElement("div", {
          "data-rehydratable-children": true
        }, children)), footer && /*#__PURE__*/React.createElement(VerticalSpacing, null, /*#__PURE__*/React.createElement("div", {
          className: _this2.getClassName({
            descendantName: "footer"
          })
        }, footer)), /*#__PURE__*/React.createElement(VerticalSpacing, null, /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(Group.Item, null, /*#__PURE__*/React.createElement(Button, {
          kind: "submit",
          color: "primary",
          disabled: isLoading || isDisabled,
          loading: isLoading
        }, buttonText)))), responseMessage ? /*#__PURE__*/React.createElement(VerticalSpacing, null, /*#__PURE__*/React.createElement("div", {
          ref: function ref(_ref3) {
            _this2.responseEl = _ref3;
          }
        }, /*#__PURE__*/React.createElement(Alert, {
          state: responseState
        }, responseMessage))) : null);
      }));
    }
  }]);

  return Form;
}(Component);

_defineProperty(Form, "displayName", "Form");

_defineProperty(Form, "responseStates", {
  NONE: "none",
  LOADING: "loading",
  SUCCESS: "success",
  FAILURE: "failure"
});

_defineProperty(Form, "propTypes", {
  /**
   * Form controls composition
   */
  children: PropTypes.node.isRequired,

  /**
   * Form action
   */
  action: PropTypes.string.isRequired,

  /**
   * Enable/disable AJAX form submission
   */
  ajax: PropTypes.bool,

  /**
   * The name of this form, used in data-form-name attribute.
   */
  formName: PropTypes.string,

  /**
   * The name of this form, used when analytics events occur.
   */
  analyticsName: PropTypes.string,

  /**
   * The type of this form, used when analytics events occur.
   */
  analyticsType: PropTypes.string,

  /**
   * The default fail message, used if no message is provided by the server.
   */
  defaultFailMessage: PropTypes.string,

  /**
   * The default success message, used if no message is provided by the server
   */
  defaultSuccessMessage: PropTypes.string,

  /**
   * Header above the form
   */
  header: PropTypes.node,

  /**
   * Form id attribute
   */
  id: PropTypes.string,

  /**
   * Footer below form controls
   */
  footer: PropTypes.node,

  /**
   * Form submission method to use. Defaults to POST for convenience.
   */
  method: PropTypes.oneOf(["get", "post"]),

  /**
   * Text on the submit button.
   */
  submitButtonText: PropTypes.string,

  /**
   * Text on the submit button when the form is in the process of submitting.
   * Not visible, but should be specified for accessibility.
   */
  submitButtonTextLoading: PropTypes.string,

  /**
   * Text shown on the submit button after a form has submitted.
   */
  submitButtonTextSuccess: PropTypes.string,

  /**
   *  Keyword indicating where to display the response that is received after
   *  submitting the form
   */
  target: PropTypes.oneOf(["_blank", "_parent", "_self", "_top"]),

  /**
   *  Override for default onFocusAnalytics behavior
   *
   */
  onFocusAnalytics: PropTypes.func,

  /**
   * Override for default onSubmit behavior
   */
  onSubmit: PropTypes.func,

  /**
   * Form noValidate attribute
   */
  noValidate: PropTypes.bool,

  /**
   * Shows if form has redirect page
   */
  hasRedirect: PropTypes.bool,

  /**
   * Redirect page url
   */
  redirectPage: PropTypes.String,

  /**
   * Message type inline or redirect
   */
  messageType: PropTypes.String,

  /**
   * Inline message for inline message type
   */
  inlineMessage: PropTypes.String,

  /**
   * Recaptcha site key
   */
  recaptchaSiteKey: PropTypes.String,

  /**
   * Recaptcha api key
   */
  recaptchaApiKey: PropTypes.String,

  /**
   * Endpoint for form submission
   */
  endpoint: PropTypes.String,

  /**
   * Eloqua form id
   */
  elqId: PropTypes.String,

  /**
   * Form resource path
   */
  formResource: PropTypes.String,

  /**
   * Shows if form has Chili Piper enabled
   */
  isChiliPiperEnabled: PropTypes.bool,

  /**
   * Chili Piper Router ID
   */
  chiliPiperRouterId: PropTypes.string
});

_defineProperty(Form, "defaultProps", {
  ajax: true,
  formName: "",
  analyticsName: "",
  analyticsType: "",
  defaultFailMessage: "An error occurred during submission.",
  defaultSuccessMessage: "Submission completed successfully.",
  method: "post",
  submitButtonText: "Submit",
  submitButtonTextLoading: "Loading",
  submitButtonTextSuccess: "Success",
  hasRedirect: false
});

Form.CampaignControl = CampaignControl;
Form.CheckboxControl = CheckboxControl;
Form.Fieldset = Fieldset;
Form.PrivacyControl = PrivacyControl;
Form.RadioControl = RadioControl;
Form.RadioInput = RadioInput;
Form.SelectControl = SelectControl;
Form.TextareaControl = TextareaControl;
Form.TextControl = TextControl;
export default Form;